import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  readonly children: ReactNode;
  readonly title?: string;
}

export function PropertiesSubpanel({ children, title }: Props) {
  return title ? (
    <Box sx={{ flex: 1, m: 1, mt: 4 }}>
      <Typography sx={{ pb: 1 }} variant="caption">
        {title}
      </Typography>
      <Box sx={{ border: 'solid 1px', borderColor: 'border.main' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>{children}</Box>
      </Box>
    </Box>
  ) : (
    <Box sx={{ flex: 1, m: 1, mt: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>{children}</Box>
    </Box>
  );
}
